export {
  initAxiosInterceptors,
  FindLoad,
  FindSuccess,
  FindError,
  useWindowSize,
  useWindowDimensions,
  SaveParams,
  SendPageSave,
  Notify,
  RenderScroll,
  ProfileInfo,
  formatPhoneNumber,
  generateDisplayId,
  DownloadFile,
} from "./hooks";
export { ModalProvider, Modals, useModal } from "./context";
export { EmailValidator, PasswordValidator } from "./validators";
export {
  originalDateConverter,
  dateConverter,
  multiConverter,
  startEndTime,
  newDateWithoutUtc,
} from "./dateConverter";
export { limit, ACCOUNT_ENUMS } from "./constants";
export const token = localStorage.getItem("access-token");

export const userInfo =
  localStorage.getItem("userInfo") &&
  JSON.parse(localStorage.getItem("userInfo"));

export const fileMaxSize = 10 * 1024 * 1024;
